// @/services/content/store/modules/submission.js
export class SubmissionHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get Submission Drawer content by locale
   * @param {string} locale Locale to get content for
   * @returns {Object|null} Content or null if not found
   */
  getContent(locale = 'en') {
    // Try requested locale first
    const localeContent = this.store.state.data.submission?.[locale];
    if (localeContent) return localeContent;
    
    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      return this.store.state.data.submission?.['en'] || null;
    }
    
    return null;
  }
}